import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Step } from '../../../shared/interfaces/step';
import { Form } from '../../../shared/interfaces/steps/form';
import { FormsCustomerInfoComponent } from '../../../shared/forms/forms-customer-info/forms-customer-info.component';
import { FormsVehicleSelectComponent } from '../../../shared/forms/forms-vehicle-select/forms-vehicle-select.component';

@Component({
    selector: 'app-step-display-form',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, FormsCustomerInfoComponent, FormsVehicleSelectComponent],
    templateUrl: './step-display-form.component.html',
    styleUrl: './step-display-form.component.scss',
})
export class StepDisplayFormComponent {
    @Input() public formGroup: FormGroup | undefined;

    @Input() public step: Step | undefined;

    public get form(): Form {
        return this.step as Form;
    }

    public get vehicleSelectMakes(): string | undefined {
        return this.step?.settings?.['vehicle_select_makes'] as string | undefined;
    }

    public control(name: string): FormControl {
        return this.formGroup?.controls?.[name] as FormControl;
    }
}
